import React, { PureComponent } from 'react';
import styled from 'styled-components';

import { Modal } from "react-bootstrap";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { pickPercent } from "./utils";

import IconTableHelp from "../../containers/assets/icon-table-help.svg";

import CapitalStructureVideo from '../../containers/assets/finance-capital-structure.mp4';
import DebtToCapitalVideo from '../../containers/assets/finance-debt-to-capital.mp4';

const videos = {
  'Capital Structure': CapitalStructureVideo,
  'Debt to Capital': DebtToCapitalVideo,
};

const HelpIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  cursor: pointer;
  margin-top: 2px;
`;

const ModalVideoWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3A507B;
  border-radius: 10px;

  &:before {
    display: block;
    content: '';
    align-items: center;
    background: #0006;
    display: flex;
    justify-content: center;
    opacity: 1;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transition: opacity .3s ease;
    border-radius: 10px;
  }

  &.is-playing:before, &.is-playing button {
    opacity: 0;
  }
  &.is-playing:hover:before, &.is-playing:hover button {
    opacity: 1;
  }
  &:hover video {
    cursor: pointer;
  }
`;

const PlayPauseButton = styled.button`
  align-items: center;
  background: none;
  background: #2a4169;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #0000001a;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 2rem;
  height: 80px;
  justify-content: center;
  padding: 0;
  text-align: center;
  width: 80px;
  z-index: 2;
  position: absolute;
  transition: opacity .3s ease;
  opacity: 1;
`;

const CloseModalVideoButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: #fff;
  padding: 0;
  line-height: normal;
`;

const TextWithButton = styled.p`
  display: flex;
  align-items: center;
`;

class CapitalStructure extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isVideoModalShown: false,
      isVideoPlaying: false,
      selectedVideo: null
    };

    this.videoRef = null;
  }

  handlePlayPause = () => {
    if (this.videoRef) {
      if (this.state.isVideoPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.setState({ isVideoPlaying: !this.state.isVideoPlaying });
    }
  };

  openVideoModal = (videoSrc) => {
    this.setState({
      isVideoModalShown: true,
      selectedVideo: videoSrc,
    });
  };

  closeVideoModal = () => {
    this.setState({
      isVideoModalShown: false,
      isVideoPlaying: false
    });
  };

  onHelpIconClick = (field) => {
    if (videos[field]) {
      this.openVideoModal(videos[field]);
    }
  };

  render() {
    const {
      isVideoModalShown,
      isVideoPlaying
    } = this.state;

    const {
      teams,
      competitionMetrics,
      metrics
    } = this.props;
    return (
      <OnePanelChart
        title={<TextWithButton>Capital Structure <HelpIcon src={IconTableHelp} onClick={() => this.onHelpIconClick("Capital Structure")} /></TextWithButton>}
        chartTitle={<TextWithButton>Debt to Capital Ratio <HelpIcon src={IconTableHelp} onClick={() => this.onHelpIconClick("Debt to Capital")} /></TextWithButton>}
        vertical
        suffix="%"
        data={pickPercent(teams, competitionMetrics, "Debt to Total Capital")}
        teams={teams}
      >
        <Modal show={isVideoModalShown} onHide={this.closeVideoModal} className="goals-and-targets-modal">
          <Modal.Body>
            <ModalVideoWrapper className={isVideoPlaying ? 'is-playing' : ''}>
              <video
                ref={(ref) => { this.videoRef = ref; }}
                src={this.state.selectedVideo}
                alt="Welcome Video"
                onClick={this.handlePlayPause}
                onEnded={() => this.setState({ isVideoPlaying: false })}
                style={{ width: '100%', borderRadius: 10 }}
              />
              <PlayPauseButton onClick={this.handlePlayPause}>
                {isVideoPlaying ? '❚❚' : '▶'}
              </PlayPauseButton>
              <CloseModalVideoButton onClick={this.closeVideoModal}>×</CloseModalVideoButton>
            </ModalVideoWrapper>
          </Modal.Body>
        </Modal>
        <Text>
          As a result of the net capital raised, your team’s new capital structure
          is {(metrics["Debt to Total Capital"] * 100).toFixed(1)}% debt and{" "}
          {((1 - metrics["Debt to Total Capital"]) * 100).toFixed(1)}% equity.
        </Text>
        <Text>
          Lenders will use your capital structure to assess the level of risks of
          your business and to help determine the rate of interests they will charge
          on lending you capital (i.e. Cost of Debt).
        </Text>
        <Text>
          Equity investors will use your capital structure to assess the risk level
          of your business to help determine the required rate of return they should
          expect for taking on the risks (i.e. Cost of Equity).
        </Text>
      </OnePanelChart>
    );
  }
}

export default CapitalStructure;



// WEBPACK FOOTER //
// ./src/components/analysis/CapitalStructure.js